import { useEffect } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { resetPassword } from "../../services/auth.services";
import { ATLEAST_ONE_CAPITAL_REGEX, ATLEAST_ONE_NUMBER_REGEX, ATLEAST_ONE_SMALL_REGEX, ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { globalLoader, handleServerValidations } from "../../../../utils/commonfunction";
import { Link } from "react-router-dom";
import logo from "../../../../assets/Discount_App_logo.png";
import loginImage from "../../../../assets/business/images/login-page-img.png";
import * as Yup from "yup";
import { useState } from "react";

const BusinessResetPassword = () => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (!state?.validate_string || state?.validate_string.length === 0) {
      navigate("/business/login");
    }
  }, [state, navigate]);

  const preventSpace = (e) => {
    // Prevent spacebar (keyCode 32) from being pressed
    if (e.keyCode === 32 || e.key === " ") {
      e.preventDefault();
    }
  };

  const resetPswValidationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .trim()
      .required("New password is required")
      .matches(ATLEAST_ONE_SMALL_REGEX, "Must contain at least one lowercase letter")
      .matches(ATLEAST_ONE_CAPITAL_REGEX, "Must contain at least one uppercase letter")
      .matches(ATLEAST_ONE_NUMBER_REGEX, "Must contain at least one number")
      .matches(ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, "Must contain at least one special character")
      .min(PASSWORD_MIN_LENGTH, `Password must be at least ${PASSWORD_MIN_LENGTH} characters`)
      .max(PASSWORD_MAX_LENGTH, `Password must be at most ${PASSWORD_MAX_LENGTH} characters`),

    confirmPassword: Yup.string()
      .trim()
      .required("Confirm password is required")
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
  });

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: resetPswValidationSchema,
    onSubmit: (values, { resetForm }) => {
      globalLoader(true);
      const formData = new FormData();
      formData.append("new_password", values.newPassword);
      formData.append("c_password", values.confirmPassword);
      formData.append("validate_string", state.validate_string);
      resetPassword(formData)
        .then((response) => {
          globalLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            navigate(`/business/password-update-page`);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          globalLoader(false);
          console.log("error--->", error);
        });
    },
  });

  return (
    <section className="welcome-screen">
      <div className="row m-0 align-items-center vh-100">
        <div className="col-md-6 p-0">
          <div className="welcome-screen-box login-box">
            <div className="welcome-screen-box-in py-4">
              <div className="back-button">
                <Link to={`/business/login`} className="d-flex align-items-center gap-2">
                  <i className="fi-rr-arrow-small-left"></i> <span>Back</span>
                </Link>
              </div>

              <div className="logo mb-4 text-center">
                <Link to={`/business/reset-password`}>
                  <img src={logo} alt="Logo" />
                </Link>
              </div>
              <div className="heading-text-auth mb-3">
                <h3 className="h3-headline text-center">Set New Password</h3>
                <p className="body-2 text-center mt-2">Create your new password</p>
              </div>

              <form onSubmit={formik.handleSubmit} className="text-start gap-3 w-100">
                <div className="text-start gap-4">
                  {/* New Password Field */}
                  <div className="input mb-3 position-relative">
                    <label className="form-label subtitle-1">
                      New Password<span className="requirestar">*</span>
                    </label>
                    <input type={showNewPassword ? "text" : "password"} className="form-control" placeholder="Enter new password" name="newPassword" value={formik.values.newPassword} onChange={formik.handleChange} onBlur={formik.handleBlur} onKeyDown={preventSpace} />
                    <div style={{ position: "absolute", top: "44%", right: "1rem", transform: "translateY(50%)", cursor: "pointer" }} onClick={() => setShowNewPassword((prev) => !prev)}>
                      <i className={`fi fi-rr-eye${showNewPassword ? "-crossed" : ""}`}></i>
                    </div>
                    {formik.touched.newPassword && formik.errors.newPassword && <div className="text-danger">{formik.errors.newPassword}</div>}
                  </div>

                  {/* Confirm Password Field */}
                  <div className="input mb-3 position-relative">
                    <label className="form-label subtitle-1">
                      Confirm Password<span className="requirestar">*</span>
                    </label>
                    <input type={showConfirmPassword ? "text" : "password"} className="form-control" placeholder="Re-enter the new password" name="confirmPassword" value={formik.values.confirmPassword} onChange={formik.handleChange} onBlur={formik.handleBlur} onKeyDown={preventSpace} />
                    <div style={{ position: "absolute", top: "44%", right: "1rem", transform: "translateY(50%)", cursor: "pointer" }} onClick={() => setShowConfirmPassword((prev) => !prev)}>
                      <i className={`fi fi-rr-eye${showConfirmPassword ? "-crossed" : ""}`}></i>
                    </div>
                    {formik.touched.confirmPassword && formik.errors.confirmPassword && <div className="text-danger">{formik.errors.confirmPassword}</div>}
                  </div>
                </div>

                <div className="get-started-btn w-50 d-flex flex-column gap-3">
                  <button type="submit" className="btn btn-oring">
                    Update Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-md-6 p-0">
          <div className="hero-img">
            <img src={loginImage} alt="Reset Password Visual" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessResetPassword;
